import { t } from '@lingui/core/macro';
import { CommonMetadataAllowedValuesFilter } from './MetadataAllowedValuesFilter';
export const documentCategoryFilterLabel = () => t({ message: 'Document category', comment: 'Insights filter: Document category' });
export function DocumentCategoryFilter() {
    return (<CommonMetadataAllowedValuesFilter name="DocumentCategory" field="metadataDocumentDocumentCategory" label={documentCategoryFilterLabel()}/>);
}
